export const SupportedLanguageCode = ['en', 'it', 'es', 'de', 'fr'];
